import { accountService } from '@/services/api/account.service'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

interface UseGetAccountInfoProps {
  accountId: string
}

async function getAccountInfo(accountId: string) {
  const response = await accountService.getAccountInfo(accountId)

  return response.data
}

export function useGetAccountInfo({ accountId }: UseGetAccountInfoProps) {
  return useQuery({
    queryKey: [QUERY_KEYS.account, accountId],
    queryFn: () => getAccountInfo(accountId),
    enabled: !!accountId,
  })
}
